import AddContactDetails from "./addContactDetails";
import POAInfo from "./poaInfo";
import POADuration from "./poaDuration";
import POASign from "./poaSign";
import POABankID from "./poaBankID";
import AdvisoryBooking from "./advisoryBooking";
import CustomerSummary from "./customerSummary";
import POAStepper from "../poaStepper";
import { Identify } from "./identify";
import {
  usePOAStepsStore,
  ENUMPOASteps,
} from "../../hooks/ui/poaStepsDataStore";
import { Dispatch, SetStateAction } from "react";
import { Box } from "@mantine/core";

const POASteps = ({
  setUserCancelled,
}: {
  setUserCancelled: Dispatch<SetStateAction<boolean>>;
}) => {
  const { currentStep } = usePOAStepsStore();
  const renderStep = () => {
    switch (currentStep) {
      case ENUMPOASteps.IDENTIFY:
        return <Identify setUserCancelled={setUserCancelled} />;
      case ENUMPOASteps.EMAILANDPHONE:
        return <AddContactDetails />;
      case ENUMPOASteps.POAINFO:
        return <POAInfo />;
      case ENUMPOASteps.POADURATION:
        return <POADuration />;
      case ENUMPOASteps.POACONFIRMATION:
        return <POASign />;
      case ENUMPOASteps.POASIGN:
        return <POABankID />;
      case ENUMPOASteps.BOOKMEETING:
        return <AdvisoryBooking />;
      case ENUMPOASteps.POASUMMARY:
        return <CustomerSummary />;
      default:
        return null;
    }
  };

  return (
    <Box>
      {!ENUMPOASteps.POASUMMARY ? null : <POAStepper />}
      {renderStep()}
    </Box>
  );
};

export default POASteps;
